import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { bindActionCreators } from "redux";
import * as downloaderActions from "../../utils/downloader/downloaderActions";
import { FormattedMessage } from "react-intl";
import { downloaderEnums } from "../../utils/downloader/downloaderEnums";
import * as simpleFetchActions from "../../../utils/simpleFetchActions";

class ToastManager extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.createFinishedDownloadToast = this.createFinishedDownloadToast.bind(
      this
    );
    this.createGeneratingToast = this.createGeneratingToast.bind(this);

    this.state = {
      generatingToasts: [],
    };
  }

  componentDidUpdate(prevProps) {
    const { simpleFetchToast } = this.props;
    this.createGeneratingToast();
    this.filterOutFinishedDownloads();

    const isPrevToastPropEmpty = prevProps.simpleFetchToast && typeof prevProps.simpleFetchToast === 'object' 
    && !Array.isArray(prevProps.simpleFetchToast) && Object.keys(prevProps.simpleFetchToast).length === 0;
    
    if(isPrevToastPropEmpty && simpleFetchToast || 
      (prevProps.simpleFetch !== simpleFetchToast)) {
      this.checkForSimpleFetchDispatch();
    }
  }

  checkForSimpleFetchDispatch() {
    const { simpleFetchToast } = this.props;
    
    if(simpleFetchToast && typeof simpleFetchToast === "string") {
      toast.dismiss();
      toast(<FormattedMessage id={simpleFetchToast} />, {
          type: toast.TYPE.ERROR,
          autoClose: false,
      });
      this.props.simpleFetchActions.resetToast(null);
    }
  }

  filterOutFinishedDownloads() {
    const downloadFailMessageId = "downloadsModal.error";
    const downloadSuccessMessageId = "downloadsModal.success";

    let error = false;

    if (
      (this.props.currentDownloads.length > 0 &&
        this.props.successDownloads.length > 0) ||
      (this.props.currentDownloads.length > 0 &&
        this.props.errorDownloads.length > 0)
    ) {
      let finishedDownload = this.props.currentDownloads.find( // If successful downloads exist. (Comparing currentDownloads with successDownloads to check.)
        (currentDownloadFile) =>
          this.props.successDownloads.some(
            (file) => file.path == currentDownloadFile.path
          )
      );

      if (!finishedDownload) { // If we didn't find successful downloads, we look for errorDownloads using the same logic. (Comparing currentDownloads with errorDownloads to check.)
        finishedDownload = this.props.currentDownloads.find(
          (currentDownloadFile) =>
            this.props.errorDownloads.some(
              (file) => file.path == currentDownloadFile.path
            )
        ); // Look also in error downloads if we didn't find a download in successDownloads.
        if (finishedDownload) {
          error = true; // Found error in downlods.
        }
      }

      if (finishedDownload) {
        this.props.downloaderActions.clearOngoing(finishedDownload.path);
        let fileToastToDismiss = this.state.generatingToasts.find(file => file.path == finishedDownload.path);

        if(fileToastToDismiss){
          toast.dismiss(fileToastToDismiss.toastId);
        }

        if (error) {
          const errorDownload = this.props.errorDownloads.find((download) => download.path == finishedDownload.path);
          this.createFinishedDownloadToast(
            downloadFailMessageId,
            finishedDownload.identifier,
            errorDownload.serverError.message
          );
        } else {
          this.createFinishedDownloadToast(
            downloadSuccessMessageId,
            finishedDownload.identifier
          );
        }
      }
    }
  }

  createFinishedDownloadToast(messageId, identifier, message) {
    let messageType = messageId.split(".");

    identifier = (
      <p>
        {identifier.split("\n").map((text, i) => (i ? [<br key={`break-${i}`} />, text] : text))}
      </p>
    ); // Replace \n with a <br/>

    toast(
      <FormattedMessage id={messageId} values={{ identifier: identifier, message:<FormattedMessage id={"validation.customMessages.serverErrors."+message} defaultMessage={<FormattedMessage id={"validation.customMessages.serverErrors.generic"}/>}/>}} />,
      {
        type: messageType[1],
        autoClose: downloaderEnums.AUTO_CLOSE,
      }
    );
  }

  createGeneratingToast() {

    if(this.props.currentDownloads.length > 0){
      let currentDownloads = this.props.currentDownloads;

      let generatingToastsArr = [];
  
      const key = this.props.toastMsg || "common.generating";
      
      for (let i = 0; i < currentDownloads.length; i++) {
        if (currentDownloads[i].showGeneratingToast && !this.state.generatingToasts.find(file => file.path == currentDownloads[i].path)) {
          let toastId = toast(
            <span className="import-export-loader">
              <span className="loader">
                <FormattedMessage id={key} />
              </span>
            </span>,
            { autoClose: false, closeButton: false }
          );
          generatingToastsArr.push({toastId: toastId, path: currentDownloads[i].path});
        }
      }
      
      if(generatingToastsArr.length > 0){
        this.setState({generatingToasts: [...this.state.generatingToasts, ...generatingToastsArr]});
      }
      
    }
  }

  render() {
    return <i className="hidden" />;
  }
}

ToastManager.propTypes = {
  simpleFetch: PropTypes.object,
  simpleFetchToast: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  simpleFetchActions: PropTypes.object,
  toastMsg: PropTypes.string,
  currentDownloads: PropTypes.array,
  successDownloads: PropTypes.array,
  errorDownloads: PropTypes.array,
  downloaderActions: PropTypes.object,
};

function mapStateToProps(state) {
  const downloads = state.downloader || {};
  const simpleFetchToast = state.simpleFetch || {};
  return {
    currentDownloads: downloads.files || [],
    errorDownloads: downloads.errorDownloads || [],
    successDownloads: downloads.successDownloads || [],
    simpleFetchToast,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    downloaderActions: bindActionCreators(downloaderActions, dispatch),
    simpleFetchActions: bindActionCreators(simpleFetchActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ToastManager);



// WEBPACK FOOTER //
// ./src/components/common/ToastManager.js